const Index = () => {
  return (
    <>
      <h1>Welcome to RowHero</h1>
      <p className="subtitle">Select an organization in the left sidebar to manage your subscription.</p>
    </>
  )
};

export default Index;